import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import Dropzone from 'react-dropzone'
import PropTypes from 'prop-types'

import BodymovinSegments from 'components/bodymovin/bodymovin_segments'
import { normalizeLocalFiles } from 'helpers/pickerNormalizer'
import { getLocalFileTypesAccepted } from 'helpers/pickerFileTypesAcceptedProvider'
import { localize } from 'helpers/translator'
import animations from 'animations/paths'

import styles from './drag_picker.scss'

const dragDropSegments = {
	idle: {segment: [0, 1], loop: false},
	active: {segment: [2, 57], loop: true},
}

class DragPicker extends PureComponent {

	constructor() {
		super()
		this.onDrop = this.onDrop.bind(this)
		this.getErrorMessage = this.getErrorMessage.bind(this)
		this.onMouseOver = this.onMouseOver.bind(this)
		this.onMouseOut = this.onMouseOut.bind(this)
		this.state = {
			segmentName: 'idle',
		}
		this.animationData = null
	}

	onMouseOver() {
		this.setState({
			segmentName: 'active',
		})
	}

	onMouseOut() {
		this.setState({
			segmentName: 'idle',
		})
	}

	onDrop(acceptedFiles, rejectedFiles) {
		this.onMouseOut()
		if (acceptedFiles.length > 0) {
			this.props.onChange(normalizeLocalFiles(acceptedFiles))
		} else if (rejectedFiles.length > 0) {
			this.props.dropRejectedHandler(this.getErrorMessage())
		}
	}

	getErrorMessage() {
		const errorMessage = []
		if (this.props.accept.includes('image')) {
			errorMessage.push('.png, .jpg, .jpeg, .pjpeg, .gif, .bmp, .pdf')
		}
		if (this.props.accept.includes('audio')) {
			errorMessage.push('.mp3, .ogg, .m4a, .wav, .aiff, .aif, .ac3, .aac, .wma')
		}
		if (this.props.accept.includes('video')) {
			errorMessage.push('.mpg, .mpeg, .mp4, .flv, .mov, .avi, .mpeg-1, .mpeg-2, .qt, .m4v, .wmv, .3gp, .asf, .ogv, .3gpp, .webm')
		}
		if (this.props.accept.includes('pdf')) {
			errorMessage.push('.pdf')
		}
		if (this.props.accept.includes('ppt')) {
			errorMessage.push('.ppt, .pptx, .odp, .pptm')
		}
		if (this.props.accept.includes('zip')) {
			errorMessage.push('.zip')
		}
		if (this.props.accept.includes('gif')) {
			errorMessage.push('.gif')
		}
		return `Invalid file type. Please upload a ${errorMessage.join(', ')}`
	}

	animationSelector = () => {
		switch (this.props.pickerType) {
			case 'audio':
			case 'audio_recorder':
				return animations.DRAG_AND_DROP_AUDIO
			case 'gif':
				return animations.DRAG_AND_DROP_GIF
			case 'image':
				return animations.DRAG_AND_DROP_IMAGE
			case 'pdf':
				return animations.DRAG_AND_DROP_PDF
			case 'video':
			case 'interactive_video':
				return animations.DRAG_AND_DROP_VIDEO
			case 'web':
			default:
				return animations.DRAG_AND_DROP_ALL
		}
	}

	render() {
		return (
			<Dropzone
				className={'hide'}
				disableClick={true}
				accept={getLocalFileTypesAccepted(this.props.accept)}
				onDragEnter={this.onMouseOver}
				onDragLeave={this.onMouseOut}
				onDrop={this.onDrop}
				multiple={this.props.multiselect}>
				<BodymovinSegments
					settings={{
						path: this.animationSelector(),
					}}
					segments={this.props.dragDropSegments || dragDropSegments}
					segment={this.state.segmentName}
				>
					<div styleName='wrapper'>
						<p styleName='text'>{localize('drag_picker_text')}</p>
					</div>
				</BodymovinSegments>
			</Dropzone>
		)
	}
}

DragPicker.propTypes = {
	animationData: PropTypes.object,
	dragDropSegments: PropTypes.object,
	accept: PropTypes.array,
	multiselect: PropTypes.bool,
	pickerType: PropTypes.string,
	onChange: PropTypes.func,
	dropRejectedHandler: PropTypes.func,
}

DragPicker.defaultProps = {
	animationData: null,
	dragDropSegments: null,
}

export default CSSModules(DragPicker, styles, {allowMultiple: true})
